/*
 * Copyright (c) 2018 CalAmp Corp.  All Rights Reserved
 */
import {assetFileTemplate} from '@ion/applications/src/components/modbus/ModbusFileGenerator';
import {Entity} from '../types/entities';
import {
  EntityTemplate,
  Template
} from '../types/templates';
import {assetsTemplate} from './AssetTemplate';
import {devicesTemplate} from './DeviceTemplate';
import {driversTemplate} from './DriverTemplate';
import {groupsTemplate} from './GroupsTemplate';
import {manufacturedDevicesTemplate} from './ManufacturedDevicesTemplate';
import {pegEventsTemplate} from './PegEventsTemplate';
import {rolesTemplate} from './RoleTemplate';
import {usersTemplate} from './UserTemplate';

export const template = ({entity, columns, workbook, options = {}}: EntityTemplate): Template => {
  const templates = {
    [Entity.asset]                     : assetsTemplate,
    [Entity.user]                      : usersTemplate,
    [Entity.operator]                  : driversTemplate,
    [Entity.toolboxModbus]             : assetFileTemplate,
    [Entity.account]                   : groupsTemplate,
    [Entity.device]                    : devicesTemplate,
    [Entity.pegevents]                 : pegEventsTemplate,
    [Entity.pegaccumulators]           : pegEventsTemplate,
    [Entity.role]                      : rolesTemplate,
    [Entity.uploadManufacturedDevices] : manufacturedDevicesTemplate
  };
  return templates[entity]?.({columns, workbook, options});
};
